export default __webpack_public_path__ + "static/media/empoweredmending.94aace09.png";